// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__5eTAC","Div":"CustomFadeBox_Div__fy2qX","LargeDiv":"CustomFadeBox_LargeDiv__1hse4"};